(function($) {

	var $el = {
		hero: $('.jq-product-hero'),
		window: $(window)
	};

	var triggers = {};

	if ($el.hero.length) {

		if ($el.hero.length > 1) {

			$el.hero = $el.hero.eq(1);

		}

		$el.stage = $('.jq-product-hero-stage', $el.hero);

		$el.card = $('.jq-product-hero-card', $el.hero);

		setHeroOverflowHeight();

		$el.window.on('resize.setHeroOverflowHeight', setHeroOverflowHeight);

	}

	function setHeroOverflowHeight() {

		if ($el.stage.length == 0 || $el.card.length == 0) {

			return;

		}

		var stateOverflow = isOverflowing($el.stage[0]);

		if (stateOverflow) {

			$el.stage.addClass('is-stacked');

			if (!('clip' in $el)) {

				$el.flow = $el.hero.wrap('<div style="position: sticky; top: 0"></div>').parent();

				$el.flow.append($el.flow.next());

				$el.clip = $el.flow.wrap('<div></div>').parent();

			}

			triggers = {
				top: $el.clip.offset().top,
				bottom: $el.stage.prop('scrollHeight') - $el.stage.height()
			};

			$el.clip.height($el.clip.height() + triggers.bottom);

			if (!('float' in $el)) {

				$el.float = $el.card.clone();

				$el.float.find('.jq-slider').remove();

				$el.stage.prepend($el.float);

			}

			$el.float.addClass('is-cloned');

			$el.card.addClass('is-stacked');

			$el.window.on('scroll.initHeroScroll', initHeroScroll);

		} else {

			$el.window.off('scroll.initHeroScroll');

			$el.stage.removeClass('is-stacked');

			$el.card.removeClass('is-stacked');

			if ('clip' in $el) {

				$el.clip.height('');

			}

			if ('float' in $el) {

				$el.float.remove();

				delete $el.float;

			}

			triggers = {};

		}

	}

	function isOverflowing(stageElement) {
		return stageElement.scrollHeight > stageElement.clientHeight;
	}

	function initHeroScroll() {

		var moveTo = Math.min(Math.max(parseInt($el.window.scrollTop() - triggers.top), 0), triggers.bottom);

		if (triggers.moveTo != moveTo || !('moveTo') in triggers) {

			triggers.moveTo = moveTo;

			$el.float
				.css(
					'transform',
					'translate3d(0, ' +
					(triggers.moveTo * -1) + 'px, ' +
					'0)'
				);

		}

	}

})(jQuery);
